import React, { useEffect } from 'react';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { toast } from "react-toastify";
import Admin from "layouts/Admin";
import LoginForm from "features/auth/LoginForm";
import EnterOtp from 'features/preOnboarding/pages/EnterOtp';
import Banner from "../src/components/common/Banner";
import Resetpassword from "features/auth/Resetpassword";
import ForgotPassword from "features/auth/ForgotPassword";
import Navbar from 'features/preOnboarding/components/EmployeeForms/Navbar';
import ProtectedRoutes from "components/common/routing/ProtectedRoutes";
import EmailVerification from 'features/preOnboarding/pages/EmailVerification';
import MultiStepOnboardingForm from 'features/preOnboarding/components/EmployeeForms/MultiStepOnboardingForm';
import GlobalLoader from 'components/common/GlobalLoader';
import CandidateVerifiedPage from 'features/portal/candidate/CandidateVerifiedPage';
import ManagePassword from 'features/portal/MeSection/MyDocuments/ManagePassword';
import PageNotFound from 'PageNotFound';
import SuccessPreview from 'features/preOnboarding/components/EmployeeForms/SuccessPreview';

export default function App() {

    useEffect(() => {
        const OFFLINE_TOAST_ID = "offline-toast";
        const handleOffline = () => {
            toast.error(
                "You are offline. Please check your internet connection.",
                {
                    toastId: OFFLINE_TOAST_ID,
                    autoClose: false,
                    closeOnClick: false,
                    draggable: false,
                    className: "toast-error-custom"
                }
            );
        };
        const handleOnline = () => {
            toast.dismiss(OFFLINE_TOAST_ID);
            toast.success("Back online!");
        };
        if (!navigator.onLine) {
            handleOffline();
        }
        globalThis.addEventListener("offline", handleOffline);
        globalThis.addEventListener("online", handleOnline);
        return () => {
            globalThis.removeEventListener("offline", handleOffline);
            globalThis.removeEventListener("online", handleOnline);
        };
    }, []);

    return (
        <BrowserRouter>
            <GlobalLoader />
            <ManagePassword />
            <Routes>
                <Route path="/" element={<LoginForm />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/reset-password" element={<Resetpassword />} />
                <Route path="/email-verification/:token" element={<EmailVerification />} />
                <Route path="/email-verification" element={<EmailVerification />} />
                <Route path="/enter-otp" element={<EnterOtp />} />
                <Route path='/preonboarding-forms' element={<MultiStepOnboardingForm />} />
                <Route path='/preonboarding-forms/success' element={<SuccessPreview/>} />
                <Route path='/candidate-verified' element={<CandidateVerifiedPage />} />
                <Route path="/banner" element={<Banner />} />
                <Route path="/admin/*" element={
                    <ProtectedRoutes>
                        <Admin />
                    </ProtectedRoutes>} />
                <Route path="/navbar" element={
                    <ProtectedRoutes>
                        <Navbar />
                    </ProtectedRoutes>
                } />

                {/* Default route */}
                <Route path="*" element={<PageNotFound />} />
            </Routes>
        </BrowserRouter>
    )
}
